import { COLORS } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import React, { CSSProperties, FC, ReactNode } from 'react';
interface Props {
  children?: ReactNode;
  className?: string;
  name?: string;
  isChecked?: boolean;
  defaultChecked?: boolean;
  value?: string | ReadonlyArray<string> | number;
  readOnly?: boolean;
  inputRef?: ((instance: HTMLInputElement | null) => void) | React.RefObject<HTMLInputElement> | null | undefined;
  onChecked?: (checked: boolean) => void;
  data?: any;
  style?: CSSProperties;
}
const CheckBox: FC<Props> = ({
  className,
  name,
  isChecked,
  defaultChecked,
  value,
  readOnly,
  inputRef,
  onChecked,
  data,
  style,
  children
}) => {
  return <CheckBoxContainer className={className} onClick={() => {
    if (onChecked) {
      onChecked(!isChecked);
    }
  }} style={style}>
      <InputCheck className={className} type="checkbox" name={name} value={value} defaultChecked={defaultChecked} checked={isChecked} readOnly={readOnly} ref={inputRef} {...data} />
      {isChecked === true ? <CheckedCheckBoxLabel>{children}</CheckedCheckBoxLabel> : <NormalCheckBoxLabel>{children}</NormalCheckBoxLabel>}
    </CheckBoxContainer>;
};
export default CheckBox;
const InputCheck = /*#__PURE__*/styled("input")({
  name: "InputCheck",
  class: "iuhl5hx"
});
const NormalCheckBoxLabel = /*#__PURE__*/styled("label")({
  name: "NormalCheckBoxLabel",
  class: "nclla1w"
});
const CheckedCheckBoxLabel = /*#__PURE__*/styled("label")({
  name: "CheckedCheckBoxLabel",
  class: "cwd2a5z"
});
const CheckBoxContainer = /*#__PURE__*/styled("div")({
  name: "CheckBoxContainer",
  class: "cyaic81"
});

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");